const SplitTestConstants = {
  ZRM_RENTERS_INSURANCE_LISTING_PATH: 'zrm-renters-insurance-listing-path',
  ZRM_TOUR_SCHEDULING_INTEGRATION: 'zrm_tour_scheduling_integration',
  ZRM_TOURING_FALSE_DOOR_TEST: 'zrm-touring-false-door-test-v2',
  ZRM_TENANT_PLACEMENT_W_PROPERTY_MANAGEMENT: 'tenant-placement-w-property-management',
  ZRM_VALUE_OF_PREMIUM: 'zrm-value-of-premium',
  ZRM_PROPERTY_DESCRIPTION_REORDER: 'zrm-property-description-reorder',
} as const;

export default SplitTestConstants;
